import React, { useEffect, useState } from 'react';
import store from 'lib/store';
import { useAudienceTrackerContext } from '../../lib/trackers/Audience';
import NotAuthorized from '../../pages/NotAuthorized';

const ClientAuth = () => {
  const [showAlert, setShowAlert] = useState(null);
  const { trackProfileOnLogin } = useAudienceTrackerContext();

  useEffect(() => {
    (async () => {
      setShowAlert(null);
      const queryParameters = new URLSearchParams(window.location.search);
      const code = queryParameters.get('code');
      const from = queryParameters.get('from');
      const err = queryParameters.get('error');
      const redirectUrl = queryParameters.get('redirectUrl');
      const userId = queryParameters.get('id');
      const email = decodeURIComponent(queryParameters.get('email')).replace(/ /g, '+');
      if (code) {
        trackProfileOnLogin({
          tracker: 'profile',
          properties: {
            email,
          },
        }, userId);
        const val = atob(code).split(':');
        store.save('accessToken', val[0].replace('Bearer ', ''), new Date(new Date().getTime() + (val[2] * 1000)));
        store.save('refreshToken', val[1].replace('Bearer ', ''), new Date(new Date().getTime() + (val[3] * 1000)));
        setTimeout(() => {
          window.location.href = redirectUrl;
        }, 1500);
      } else if (from) {
        const refTk = await store.get('refreshToken');
        const payload = {
          refreshToken: `Bearer ${refTk}`,
        };
        const requestOptions = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        };
        fetch(`${process.env.MS_API_GATEWAY_URL}/api/iam/v1/auth/refreshToken`, requestOptions)
          .then(res => {
            if (res.ok) {
              return res.json();
            }
            return res;
          })
          .then(res => {
            if (res.status === 401) {
              store.delete('accessToken');
              store.delete('refreshToken');
              window.location = '/sign-in';
            } else {
              store.save('accessToken', res.accessToken.replace('Bearer ', ''), new Date(new Date().getTime() + (res.accessTokenMaxAge * 1000)));
              store.save('refreshToken', res.refreshToken.replace('Bearer ', ''), new Date(new Date().getTime() + (res.refreshTokenMaxAge * 1000)));
              window.location = from;
            }
          })
          // eslint-disable-next-line no-console
          .catch((e) => console.log(e));
      } else if (err) {
        setShowAlert(err);
      }
    })();
  }, []);

  return (
    <>
      {showAlert && (
        <NotAuthorized message={`You dont have permission to login. ${showAlert}`} />
      )}
      {!showAlert && <div>Please wait...</div>}
    </>
  );
};

export default ClientAuth;
